/**
 * Веб-расширение протокола для внутренних маршрутов сервиса.
 *
 * Зеркалирование маршрутов сервиса в адресную строку оболочки УБРАНО в пользу нативной
 * canGoBack-модели (см. iframe-bridge.tsx): сервис сообщает наличие внутренней истории через
 * `navigation.setCanGoBack`, а оболочка перехватывает браузерный «назад» (useBlocker) и шлёт
 * сервису `back.pressed`. URL сервиса остаётся одной записью истории.
 *
 * - `routeChanged` (сервис → оболочка): сервис всё ещё может слать его при навигации — оболочка
 *   просто подтверждает приём, в URL ничего не зеркалит.
 * - `setRoute` оставлен в перечне для совместимости протокола, оболочкой больше не отправляется.
 */
export const ROUTE_SYNC = {
  routeChanged: 'navigation.routeChanged',
  setRoute: 'navigation.setRoute'
} as const;

/** Payload сообщений роут-синка. */
export interface IRouteSyncPayload {
  path: string;
}
